import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'xs-lib-datatimepicker',
  templateUrl: './datatimepicker.component.html',
  styleUrls: ['./datatimepicker.component.css']
})
export class DatatimepickerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
